module.exports = __webpack_public_path__ + "img/FMSicon2.01f1bc01.png";